<div class="profile-container">
  <div style="cursor: pointer;" [matMenuTriggerFor]="profileMenu"
    class="profile-btn d-flex align-items-center justify-content-between">
    <img class="avatar" src="assets/site-icons/profile_icon.png" alt="Profile" />
    <div class="profile-info d-flex flex-column">
      <div class="profile-name" [title]="profileName">
        {{ (profileName?.length > 12) ? (profileName | slice:0:12) + '..' : profileName }}
      </div>
      <div class="profile-role" style="color: var(--mainC);">User</div>
    </div>
  </div>

  <!-- Mat Menu -->
  <mat-menu #profileMenu="matMenu" yPosition="below" class="custom-menu-panel bg-transparent">
    <!-- <button mat-menu-item style="color: var(--textL);font-weight: 400;" (click)="onMenuClick('profile')">
      <img src="../../../../assets/icons/DropUser.svg" alt="" class="me-2">
      <span class="pera">Profile</span>
    </button> -->
    <button mat-menu-item style="color: var(--textL);font-weight: 400;" (click)="onMenuClick('password')">
      <img src="../../../../assets/icons/DropPassword.svg" alt="" class="me-2">
      <span class="pera">Change Password</span>
    </button>
    <button mat-menu-item style="color: var(--textL);font-weight: 400;" (click)="onMenuClick('social')">
      <img src="../../../../assets/icons/DropSocialMedia.svg" alt="" class="me-2">
      <span class="pera">Social Media Settings</span>
    </button>
    <button *ngIf="is2FA === 'No'" mat-menu-item style="color: var(--textL);font-weight: 400;"
      (click)="onMenuClick('2fa')">
      <img src="../../../../assets/icons/DropSecurity.svg" alt="" class="me-2">
      <span class="pera">Enable 2FA</span>
    </button>
    <button *ngIf="is2FA === 'Yes'" mat-menu-item style="color: var(--textL);font-weight: 400;"
      (click)="onMenuClick('2fa')">
      <img src="../../../../assets/icons/DropSecurity.svg" alt="" class="me-2">
      <span class="pera">Disable 2FA</span>
    </button>
    <button mat-menu-item style="color: var(--textL);font-weight: 400;" (click)="onMenuClick('logout')">
      <img src="../../../../assets/icons/DropLogout.svg" alt="" class="me-2">
      <span class="pera">Logout</span>
    </button>
  </mat-menu>
</div>

<!-- 2FA Modal -->
<ng-template #modalContent let-data>
  <div class="modal-content p-4 pb-0">
    <div class="modal-header d-flex justify-content-between w-100 mb-2">
      <h5 class="mb-0">{{ data.action === 'enable2fa' ? 'Enable' : 'Disable' }} Two-Factor Authentication
      </h5>
      <button type="button" class="btn-close ms-5" data-bs-dismiss="modal" aria-label="Close"
        (click)="closeModal()"></button>
    </div>
  </div>
  <div class="modal-body p-3 pt-0">
    <div class="p-2 pb-0" *ngIf="data.action === 'enable2fa' && !show2FARegistrationModal">
      <p class="mt-2 mb-2 pera">Are you sure you want to enable 2FA for your account?</p>
      <div class="d-flex justify-content-center gap-3 align-items-center m-auto pb-3 pt-2">
        <button class="mainBtn" (click)="on2FAModalAction('enable2fa')">Enable 2FA</button>
        <!-- <button class="mainBtn outlineBtn" (click)="closeModal()">Cancel</button> -->
      </div>
    </div>
    <div class="p-2" *ngIf="data.action === 'disable2fa' && !show2FARegistrationModal">
      <p class="mt-2 mb-2 pera">Are you sure you want to disable 2FA for your account?</p>
      <!-- <p>Please provide a reason for disabling 2FA:</p>
      <select class="input-group" [(ngModel)]="reportIssue"
          style="cursor: pointer;height: 50px;">
          <option value="null" selected>Select Reason</option>
        <option *ngFor="let item of listofReportsIssues" [ngValue]="item">{{ item }}</option>
      </select> -->
      <div class="d-flex justify-content-center gap-3 align-items-center m-auto pb-4">
        <button class="mainBtn" (click)="on2FAModalAction('disable2fa')">Disable 2FA</button>
        <!-- <button class="mainBtn outlineBtn" (click)="closeModal()">Cancel</button> -->
      </div>
    </div>

    <!-- 2FA Registration Modal -->
    <div *ngIf="show2FARegistrationModal" class="twofa-modal">
      <div class="twofa-content"
        style="display:flex;flex-direction:column;align-items:center;min-height:320px;padding:16px;">
        <h4 class="mb-3">Scan QR Code</h4>

        <div class="qr-wrapper" style="display:flex;align-items:center;justify-content:center;width:100%;">
          <img *ngIf="qrCodeImage" [src]="qrCodeImage" alt="QR Code"
            style="max-width:260px;width:100%;height:auto;border:1px solid #e9e9e9;padding:10px;border-radius:8px;background:#fff;" />
        </div>

        <p class="text-center mt-3 mb-0" style="color:var(--muted,#666);font-size:14px;">
          Open your authenticator app and scan the QR code above. After scanning, click "Confirm Registration".
        </p>

        <div style="flex:1;"></div>

        <div class="twofa-actions" style="width:100%;display:flex;justify-content:center;gap:12px;padding-top:12px;">
          <button class="mainBtn" (click)="proceedTo2FAVerification()" style="min-width:160px;">
            Confirm Registration
          </button>
          <button class="mainBtn outlineBtn" (click)="closeModal()" style="min-width:160px;">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Social Media Login Modal -->
<ng-template #socialMediaModal>
  <div class="modal-content p-4 pb-0">
    <div class="modal-header d-flex justify-content-between w-100 mb-2">
      <h5 class="mb-0">Social Media Login Settings</h5>
      <button type="button" class="btn-close ms-5" data-bs-dismiss="modal" aria-label="Close"
        (click)="closeModal()"></button>
    </div>
  </div>

  <div class="modal-body p-4 py-0">
    <p class="mt-2 mb-2 pera">Do you want to enable social media login?</p>
    <div class="d-flex gap-3 align-items-center justify-content-center m-3">
      <input type="radio" name="enableSocial" [(ngModel)]="enableSocialLogin" value="enable" /> Enable
      <input type="radio" name="enableSocial" [(ngModel)]="enableSocialLogin" value="disable" /> Disable
    </div>

    <div class="mb-3">
      <select id="socialType" class="input-group" [(ngModel)]="socialMediaType" name="socialMediaType"
        style="cursor:pointer;height:50px;">
        <option value="null" disabled selected>Social Media provider</option>
        <option value="google">Google</option>
        <option value="twitter">Twitter</option>
        <option value="facebook">Facebook</option>
        <option value="apple">Apple</option>
      </select>
    </div>

    <div class=" mt-2 d-flex justify-content-center gap-3 align-items-center m-auto pb-4">
      <button class="mainBtn" (click)="saveSocialSettings()">Proceed</button>
      <!-- <button class="mainBtn outlineBtn" (click)="closeModal()">Cancel</button> -->
    </div>
  </div>
</ng-template>
<!-- Profile Modal -->
<ng-template #profileModal>
  <div class="modal-content p-4 pb-0">
    <div class="modal-header d-flex justify-content-between w-100">
      <h5 class="mb-0">Profile</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        (click)="closeModal()"></button>
    </div>
  </div>

  <div class="modal-body p-3">
    <table class="AcDT mb-3">
      <tr>
        <td><strong>User ID:</strong></td>
        <td><small style="color: var(--textC);">{{ userId || '-' }}</small></td>
      </tr>
      <tr>
        <td><strong>User Name:</strong></td>
        <td><small style="color: var(--textC);">{{ profileName || '-' }}</small></td>
      </tr>
      <tr>
        <td><strong>Email:</strong> </td>
        <td><small style="color: var(--textC);">{{ email || '-' }}</small></td>
      </tr>
      <tr>
        <td><strong>Mobile:</strong></td>
        <td><small style="color: var(--textC);">{{ mobile || '-' }}</small></td>
      </tr>
      <tr>
        <td><strong>Role:</strong></td>
        <td><small style="color: var(--textC);">User</small></td>
      </tr>
    </table>
    <!-- <div class="p-2 d-flex gap-3 flex-wrap">
      <div><strong>User ID:</strong> <small class="ms-2" style="color: var(--textC);">{{ userId || '-' }}</small></div>
      <div><strong>User Name:</strong> <small class="ms-2" style="color: var(--textC);">{{ profileName || '-' }}</small></div>
      <div><strong>Email:</strong> <small class="ms-2" style="color: var(--textC);">{{ email || '-' }}</small></div>
      <div><strong>Mobile:</strong> <small class="ms-2" style="color: var(--textC);">{{ mobile || '-' }}</small></div>
      <div><strong>Role:</strong> <small class="ms-2" style="color: var(--textC);">User</small></div>
    </div> -->

    <!-- <div class="d-flex justify-content-center gap-3 align-items-center m-auto pb-4">
      <button class="mainBtn" (click)="closeModal()">Close</button>
    </div> -->
  </div>
</ng-template>
